import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { useLocation, Link } from "react-router-dom";
import axiosInstance from "../axiosInstance"; // Import axiosInstance
import "../pages/counttable.css";

const CountTable = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  const date1Param = searchParams.get("date1");
  const date2Param = searchParams.get("date2");

  const [showPopup, setShowPopup] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState(""); // Search state
  const recordsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }

      const startDate = date1Param
        ? new Date(date1Param).toISOString().split("T")[0]
        : null;
      const endDate = date2Param
        ? new Date(date2Param).toISOString().split("T")[0]
        : null;

      const apiMap = {
        "upload-list": "/pifir/upload-list/",
        "complete-list": "/pifir/complete-list/",
        "pending-list": "/pifir/pending-list/",
        "very-easy-list": "/pifir/very-easy-list/",
        "easy-list": "/pifir/easy-list/",
        "neutral-list": "/pifir/neutral-list/",
        "difficult-list": "/pifir/difficult-list/",
        "very-difficult-list": "/pifir/very-difficult-list/",
      };

      const url = apiMap[type];

      if (!url) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const response = await axiosInstance.post(
          url,
          {
            start_date: startDate,
            end_date: endDate,
            offset: 0,
            size: Number.MAX_SAFE_INTEGER,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setTableData(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setTableData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [type, date1Param, date2Param]);

  // Search Functionality
  const handleSearch = () => {
    setCurrentPage(1); // Reset pagination on search
  };

  const handleShowPopup = (vehicleNumber) => {
    setPopupMessage(
      `Feedback for registration number ${vehicleNumber} is already submitted.`
    );
    setShowPopup(true);
  };

  const filteredData = tableData.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Pagination Logic
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.max(
    1,
    Math.ceil(filteredData.length / recordsPerPage)
  );

  // Function to get heading text dynamically
  const getHeading = () => {
    const headings = {
      "upload-list": "Uploaded List",
      "complete-list": "Completed List",
      "pending-list": "Pending List",
      "very-easy-list": "Very Easy List",
      "easy-list": "Easy List",
      "neutral-list": "Neutral List",
      "difficult-list": "Difficult List",
      "very-difficult-list": "Very Difficult List",
    };
    return headings[type] || "Count Details";
  };

  const handlePrint = () => {
    const printContents = document.getElementById("printSection").innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // Reload to restore original page
  };

  return (
    <div className="maindiv">
      <div className="headingdiv">
        <h2>{getHeading()}</h2>
        <button className="printbutton" onClick={handlePrint}>
          Print
        </button>
      </div>

      {/* Search Box */}
      <div className="searchdiv">
        <input
          className="searchinput"
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button
          onClick={handleSearch}
          style={{
            padding: "8px 12px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Search
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div id="printSection">
            <Table className="custom-table" striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Mobile No</th>
                  <th>Vehicle No</th>
                  <th>Created Date</th>
                  <th>Feedback 1</th>
                  <th>Comment 1</th>
                  <th>Feedback 2</th>
                  <th>Comment 2</th>
                  <th>Feedback Link</th>
                </tr>
              </thead>
              <tbody>
                {currentRecords.length > 0 ? (
                  currentRecords.map((item, index) => (
                    <tr key={index}>
                      <td>{item.srno || "N/A"}</td>
                      <td>{item.mobileno || "N/A"}</td>
                      <td>{item.vehicleno || "N/A"}</td>
                      <td>
                        {item.created_at
                          ? new Date(item.created_at).toLocaleDateString(
                              "en-GB"
                            )
                          : "N/A"}
                      </td>
                      <td className="text-center">
                        <span
                          className="badge"
                          style={{
                            backgroundColor:
                              item.feedback1 === 4 || item.feedback1 === 5
                                ? "red"
                                : item.feedback1 >= 1 && item.feedback1 <= 3
                                ? "green"
                                : "red",
                          }}
                        >
                          {item.feedback1 || "N/A"}
                        </span>
                      </td>
                      <td>{item.comment1 || "N/A"}</td>
                      <td className="text-center">
                        <span
                          className="badge"
                          style={{
                            backgroundColor:
                              item.feedback2 === 4 || item.feedback2 === 5
                                ? "red"
                                : item.feedback2 >= 1 && item.feedback2 <= 3
                                ? "green"
                                : "red",
                          }}
                        >
                          {item.feedback2 || "N/A"}
                        </span>
                      </td>
                      <td>{item.comment2 || "N/A"}</td>

                      <td>
                        {item.feedback_link && item.otp_value > 0 ? (
                          item.feedback_collection === 1 ? (
                            <span
                              style={{
                                display: "block",
                                fontSize: "20px",
                                color: "gray",
                                cursor: "pointer",
                              }}
                              onClick={() => handleShowPopup(item.vehicleno)}
                            >
                              Feedback
                            </span>
                          ) : (
                            <Link
                              to={`/rating?view_key=${new URL(
                                item.feedback_link
                              ).searchParams.get("view_key")}`}
                              style={{ display: "block", fontSize: "20px" }}
                              state={{
                                srNumber: item.srno,
                                vehicleNumber: item.vehicleno,
                              }}
                            >
                              Feedback
                            </Link>
                          )
                        ) : (
                          "N/A"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: "center" }}>
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          {/* Pagination Controls */}
          <div
            style={{ textAlign: "center", marginTop: "20px", height: "200px" }}
          >
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span style={{ margin: "0 10px" }}>
              Page {totalPages > 0 ? currentPage : 0} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}

      {showPopup && (
        <div className="popupdiv">
          <p>{popupMessage}</p>
          <button className="popupclosebtn" onClick={() => setShowPopup(false)}>
            Ok
          </button>
        </div>
      )}

      {/* Background Overlay */}
      {showPopup && (
        <div
          onClick={() => setShowPopup(false)}
          className="popupbgoverlay"
        ></div>
      )}
    </div>
  );
};

export default CountTable;
